<script lang="ts" setup>
const props = defineProps<{
    pager: Pager;
}>();

const displayedFromRange = computed((): number =>
{
    return (props.pager.pageIndex - 1) * props.pager.pageSize + 1;
});

const displayedToRange = computed((): number =>
{
    if (props.pager.totalRows < props.pager.pageSize)
    {
        return props.pager.totalRows;
    }
    else
    {
        const result = props.pager.pageIndex * props.pager.pageSize;

        if (result > props.pager.totalRows)
            return props.pager.totalRows;

        return result;
    }
});

const totalCount = computed((): number => props.pager.totalRows);
</script>

<template>
    <span v-if="pager && pager.totalRows > 0 && pager.totalRows < Number.MAX_SAFE_INTEGER">
        {{ $t('[[[Wyświetlam]]]') }} [{{ displayedFromRange }}-{{ displayedToRange }}] z {{ totalCount }}
    </span>
</template>
